/* eslint-disable @typescript-eslint/no-unused-vars */
import { NavItems } from "../common/helpers/navigation";
import { Flow } from "../common/store/assessmentFlowSlice";

export const LIST_A = 0;
export const LIST_B = 1;

export const getPresentTargets = (list: number, trial: number): Flow => ({
    name: `List ${list === LIST_A ? "A" : "B"} Present Targets ${trial}`,
    path: NavItems.Assessments.Instruction.path,
    list
});

export const getFreeRecalls = (list: number, trial: number): Flow => ({
    name: `List ${list === LIST_A ? "A" : "B"} Free Recall ${trial}`,
    path: trial === 2 ? NavItems.Assessments.InstructionCountdown.path : NavItems.Assessments.AssessmentFreeRecall.path,
    list
});

export const getCuedRecalls = (list: number, trial: number): Flow => ({
    name: `List ${list === LIST_A ? "A" : "B"} Cued Recall ${trial}`,
    path: NavItems.Assessments.AssessmentCuedRecalls.path,
    list
});

const listATrial1 = [getPresentTargets(LIST_A, 1), getFreeRecalls(LIST_A, 1), getCuedRecalls(LIST_A, 1)];
const listBTrial1 = [getPresentTargets(LIST_B, 1), getFreeRecalls(LIST_B, 1), getCuedRecalls(LIST_B, 1)];
const listATrial2 = [getPresentTargets(LIST_A, 2), getCuedRecalls(LIST_A, 2)];
const listBTrial2 = [getPresentTargets(LIST_B, 2), getCuedRecalls(LIST_B, 2)];

// const listATrial3 = [getFreeRecalls(LIST_A, 2), getCuedRecalls(LIST_A, 3)];

export const delayedAB = [
    {
        name: "Delayed Free Recall A & B",
        path: NavItems.Assessments.AssessmentDelayedRecall.path,
        list: -1
    }
];

export const fullFlow: Flow[] = listATrial1.concat(listATrial2, listBTrial1, listBTrial2);
